<template>
    <div class="position-relative">
        <v-btn fab x-small color="red" dark
               v-show="filter_presence !== -1 && filter_presence !== null"
               @click="filter_presence = -1 ; $emit('update', filter_presence)"
               style="position: absolute; right: 0; top: 0; z-index: 4">
            <v-icon>mdi-filter-remove-outline</v-icon>
        </v-btn>
        <v-radio-group
            :class="css_class || ''"
            v-model="filter_presence"
            hide-details
            label="Form"
            @change="$emit('update', filter_presence)"
        >
            <!--<v-radio
                label="-"
                :value="-1"
            ></v-radio>-->
            <v-radio
                v-for="(val, key) in presences"
                :key="key"
                :label="getResolvedAppointmentPresence(key).label"
                :value="key"
            ></v-radio>
        </v-radio-group>
    </div>
</template>

<script>

import _ from 'lodash'

export default {
    components: {},
    props : ['css_class'],
    data : () => ({
        filter_presence : null,
    }),
    computed : {
        presences () {
            if(_.get(this.$root, 'enums.byKey.appointment_presence_types', false) !== false) {
                return this.$root.enums.byVal.appointment_presence_types
            }
            else
                return {}
        }
    },
    created () {},
    mounted () {},
    methods : {
        reset () {
            this.filter_presence = null
        }
    }
};
</script>
